import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { AsyncHorizontalProjectNav } from '@atlassian/jira-business-horizontal-nav/src/async.tsx';
import { businessProjectLayout } from '@atlassian/jira-business-project-layout/src/index.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { ROUTE_GROUPS_CLASSIC_BUSINESS } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import {
	createPageEntryPoint,
	createChromelessEntryPoint,
} from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { activityFeedResource } from '@atlassian/jira-router-resources-business-summary-activity-feed/src/index.tsx';
import { summaryDataResource } from '@atlassian/jira-router-resources-business-summary-data/src/index.tsx';
import { jiraBusinessSummaryEmbedRoute } from '@atlassian/jira-router-routes-business-summary-routes/src/jiraBusinessSummaryEmbedRoute.tsx';
import { jiraBusinessSummaryRoute } from '@atlassian/jira-router-routes-business-summary-routes/src/jiraBusinessSummaryRoute.tsx';
import { summaryEmbedEntrypoint } from '@atlassian/jira-spa-apps-business-summary-embed/entrypoint.tsx';
import { summaryEntrypoint } from '@atlassian/jira-spa-apps-business-summary/entrypoint.tsx';
import SummaryEmbedView, { LazySummaryEmbeddedView } from './summary-embed/index.tsx';
import SummaryView, { LazySummaryView } from './summary/index.tsx';

const summaryPageEntrypoint = createPageEntryPoint({
	main: summaryEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const jiraBusinessSummaryRouteEntry = createEntry(jiraBusinessSummaryRoute, () => ({
	group: ROUTE_GROUPS_CLASSIC_BUSINESS,
	ufoName: 'jwm.summary-view',
	component: SummaryView,
	layout: businessProjectLayout,
	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		// delete when cleaning up getWillShowNav4
		sidebar: AsyncSidebarCore,
		horizontal: AsyncHorizontalProjectNav,
	},

	resources: [...getProjectViewResources(), summaryDataResource, activityFeedResource],
	forPaint: [LazyAtlassianNavigation, LazySummaryView],

	entryPoint: () =>
		fg('sv-6_migrate_summary_page_entrypoint') ? summaryPageEntrypoint : undefined,
}));

const summaryEmbedPageEntrypoint = createChromelessEntryPoint({
	main: summaryEmbedEntrypoint,
});

export const jiraBusinessSummaryEmbedRouteEntry = createEntry(
	jiraBusinessSummaryEmbedRoute,
	() => ({
		group: ROUTE_GROUPS_CLASSIC_BUSINESS,
		ufoName: 'jwm.summary-view-embed',
		component: SummaryEmbedView,
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,

		resources: [...getProjectViewResources(), summaryDataResource, activityFeedResource],
		forPaint: [LazySummaryEmbeddedView],

		entryPoint: () =>
			fg('sv-6_migrate_summary_page_entrypoint') ? summaryEmbedPageEntrypoint : undefined,
	}),
);
